export function generateAnArrayWithIndexes(
    arrayLimitLength: number,
    start: number,
    step: number
): number[] {
    const indexses: number[] = [];

    let i = 0;
    let startValue: number = start;
    while (i < arrayLimitLength) {
        indexses.push(startValue);
        startValue = startValue + step;
        i++;
    }

    return indexses;
}